import { render, staticRenderFns } from "./RegosStats.vue?vue&type=template&id=553a410d&scoped=true&"
import script from "./RegosStats.vue?vue&type=script&lang=js&"
export * from "./RegosStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a410d",
  null
  
)

export default component.exports